<ng-container *ngIf="isExpansionNode">
  <div class="tree-node">
    <mood-dataset-node [showMenu]="showMenu" [node]="node" [expanded]="expanded"
      (datasetClicked)="expandNode()"></mood-dataset-node>
  </div>

  <div class="sub-nodes" *ngIf="expanded">
    <!-- {{ groupNode | json }} -->
    <mood-tree-node [showMenu]="showMenu" *ngFor="let subNode of filteredChildren" [entryIcon]="entryIcon"
      [entryClicked]="entryClicked" [node]="subNode" [expandDueToSearch]="expandDueToSearch"></mood-tree-node>
  </div>
</ng-container>

<ng-container *ngIf="isTimeSeriesNode">
  <div class="tree-node">
    <mood-dataset-node [showMenu]="showMenu" [node]="node" [icon]="entryIcon || 'format-title'"
      (datasetClicked)="addTimeseriesClicked()"></mood-dataset-node>
  </div>
</ng-container>

<ng-container *ngIf="isDatasetNode && !isExpansionNode && !isTimeSeriesNode">
  <div class="tree-node">
    <mood-dataset-node [showMenu]="showMenu" [node]="node" [icon]="entryIcon || 'plus'"
      (datasetClicked)="addLayerToBrowser(node)"></mood-dataset-node>
  </div>
</ng-container>
